<template>
    <div>
        <div class="text-center">
            <h2 class="fw-bold">{{ invoice.sequence }}</h2>
            <span class="navbar-brand mb-0 h3 fw-bold text-nowrap align-items-center">
               <span class="badge" :class="statusStyle.badge">{{ transStatus }}</span>
            </span>
        </div>
        <hr>
        <div class="card bg-gray-100 py-2 px-3 mt-3">
            <div class="detail-item d-flex justify-content-between py-3">
                <div class="text-dark">{{ trans('general.component.profile_widget.invoice_form.issue_date') }}</div>
                <div class="fw-bold"> {{ invoice.issue_date | moment('DD-MM-YYYY') }}</div>
            </div>
            <div class="detail-item d-flex justify-content-between py-3" v-if="invoice.due_date">
                <div class="text-dark">{{ trans('general.component.profile_widget.invoice_form.due_date') }}</div>
                <div class="fw-bold " :class="{'text-danger overdue': isOverdue}">
                    {{ invoice.due_date | moment('DD-MM-YYYY') }}
                </div>
            </div>
        </div>
        <div class="card bg-gray-100 py-2 px-3 mt-3">
            <div class="detail-item d-flex justify-content-between py-3">
                <div class="text-dark">{{ trans('general.component.profile_widget.invoice_form.amount') }}</div>
                <div class="fw-bold"> {{ getCurrency }} {{ amount }}</div>
            </div>
            <div class="detail-item d-flex justify-content-between py-3" v-if="this.invoice?.tax">
                <div class="text-dark">{{ trans('general.component.profile_widget.invoice_form.tax') }}
                    {{ this.invoice?.tax?.value }} %
                </div>
                <div class="fw-bold">{{ getCurrency }} {{ tax }}</div>
            </div>
            <div class="detail-item d-flex justify-content-between py-3">
                <div class="text-dark fw-bold">{{ trans('general.component.profile_widget.invoice_form.total') }}</div>
                <div class="fw-bolder fs-18 text-end ">
                    <div> {{ getCurrency }} {{ total }}</div>
                    <div class="text-success" v-if="formInvoice.open_balance > 0 && paid > 0"> {{ getCurrency }} {{
                            paid
                        }}
                    </div>
                </div>
            </div>
        </div>
        <br>

        <div class="mt-3" v-if="formInvoice.status === STATUS_OPEN">
            <div class="header" v-if="confirmationSent">
                <h5 class="mb-1 fw-bold">
                    {{ trans('general.component.profile_widget.invoice_form.confirmation_sent') }}:</h5>
                <p class="fs-12 text-success"> {{ confirmationSent|moment('DD-MM-YYYY hh:mm') }} </p>
                <p class="alert alert-info">{{ formInvoice.current_status.message }}</p>

                <div v-if="formInvoice.documents.length > 0" class="documents" v-for="document in formInvoice.documents">
                    <invoice-document-item :document="document"/>
                </div>
            </div>
            <div v-else class="header">
                <h5 class="mb-1 fw-bold">{{ trans('general.component.profile_widget.invoice_form.header') }} </h5>
                <p class="fs-12 mb-0">{{ trans('general.component.profile_widget.invoice_form.info') }} </p>
            </div>
            <form class="form mt-2 mb-5" @submit.prevent="submit" ref="confirmForm">
                <div class="mb-2">
                    <div class="form-floating">
                        <textarea class="form-control" v-model="model.message" required
                                  placeholder=" " name="message"> </textarea>
                        <label for="date">{{ trans('general.component.profile_widget.invoice_form.message') }} </label>
                        <i @click="showInfo = !showInfo"
                           class="fi hov-pointer fi-rr-interrogation position-absolute right-0 bottom-0 mb-2 me-2"></i>
                    </div>
                    <small v-if="showInfo">
                        <i>{{ trans('general.component.profile_widget.invoice_form.message_info') }}</i>
                    </small>
                </div>

                <div class="mb-2">
                    <input ref="filesSelect" class="d-none" id="chooseFiles" type="file"
                           accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                           v-on:change="selectedFiles($event)"/>
                    <div class="card p-1 ">
                        <div>
                            <div class="d-flex w-100 justify-content-between  gap-2 ">
                                <div class="border-radius-20 border-dark p-2 w-100 text-center fs-12 hov-pointer"
                                     v-if="files.length < 1" @click="() => $refs.filesSelect.click()"
                                     style="border: dashed 2px #3c3c3c">
                                    <i class="fi fi-rr-upload"></i>
                                    <span>{{ trans('general.component.profile_widget.invoice_form.click_to_upload') }}</span>
                                </div>
                            </div>

                        </div>
                        <div v-if="files.length > 0" class="mt-2">
                            <div v-for="(file, index) in files"
                                 class="d-flex justify-content-between w-100 p-2 me-2 bg-gray-100 rounded-3 cursor help"
                                 :title="trans('general.page.space_billing.invoice.messages.click_save_to_upload')"
                            >
                                <div class="d-flex align-items-center text-primary  ov">
                                    <div class="max-w-50 me-2 "><i class="fi fi-rr-document"></i></div>
                                    <div class="name max-w-200">{{ file.name }}</div>
                                </div>
                                <div class="actions">
                                    <button type="button" class="btn btn-circle btn-sm btn-delete btn-secondary "
                                            v-on:click="files.splice(index, 1)"><i class="fi fi-rr-cross"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <nav class="position-absolute w-100 nav navbar-light bg-gray-100 bottom-0 right-0 px-4 py-1 py-lg-2 gap-2 justify-content-end">
                    <button class="btn btn-primary  btn-icon-split" type="submit">
                        <waiting-indicator-icon :name="INVOICE_SUBMISSION_INDICATOR"
                                                color="success"
                                                icon="fi-rr-paper-plane"></waiting-indicator-icon>
                        <span class="text">{{ trans('general.defaults.send') }}</span>
                    </button>
                </nav>
            </form>
        </div>

    </div>
</template>

<script>
import {EMIT_INVOICES_CHANGE, STATUS_OPEN, statusStyle, transStatus} from "../../../services/SpaceBillingContants";
import {round} from "../../../services/MathFunctions";
import moment from "moment"
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon.vue";
import InvoiceDocumentItem from "../atoms/InvoiceDocumentItem.vue";

const INVOICE_SUBMISSION_INDICATOR = 'INVOICE_SUBMISSION_INDICATOR'

export default {
    name: "InvoiceForm",
    components: {InvoiceDocumentItem, WaitingIndicatorIcon},
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            STATUS_OPEN,
            INVOICE_SUBMISSION_INDICATOR,
            confirmationSent: this.invoice?.current_status?.media_id ? this.invoice?.current_status?.created_at : null,
            formInvoice: this.invoice,
            files: [],
            showInfo: false,
            model: {
                message: null,
                file: null
            }
        }
    },
    computed: {
        getCurrency() {
            return this.formInvoice?.currency?.symbol ?? 'EUR'
        },
        transStatus() {
            return transStatus(this.formInvoice.status)
        },

        statusStyle() {
            return statusStyle(this.formInvoice.status);
        },
        calculateTax() {
            if (!this.formInvoice.tax) return 0;

            return (this.formInvoice.amount / (100 / Number(this.formInvoice.tax.value) + 1));
        },
        tax() {
            return round(this.calculateTax / 100, 2).toFixed(2);
        },
        amount() {
            return round((this.formInvoice.amount - this.calculateTax) / 100, 2).toFixed(2);
        },
        total() {
            return round((this.formInvoice.amount) / 100, 2).toFixed(2);
        },
        paid() {
            return round((this.formInvoice.amount - this.formInvoice.open_balance) / 100, 2).toFixed(2);
        },
        isOverdue() {
            return this.formInvoice?.due_date && this.formInvoice.status === STATUS_OPEN && moment(this.formInvoice.due_date).isBefore();
        }
    },
    methods: {
        selectedFiles(event) {
            for (let file of event.target.files) {
                this.files.push(file)
            }
        },
        submit(event) {
            event.preventDefault();
            this.errors = [];
            this.$wait.start(INVOICE_SUBMISSION_INDICATOR);

            const form = this.parseForm(event.target)
            this.confirmationSent = false;

            axios.post(`children/${this.formInvoice.child_id}/invoice/${this.formInvoice.id}/send-confirmation`,
                form, {headers: {'content-type': 'multipart/form-data'}})
                .then(response => {
                    const currentStatus = response.data.data.current_status;
                    this.formInvoice = response.data.data;
                    this.confirmationSent = currentStatus.media_id ? currentStatus.created_at : null;
                    this.$refs.confirmForm.reset();
                    this.model = {message: null, file: null};
                    this.files = [];
                    this.loadInvoice();

                    this.$emit(EMIT_INVOICES_CHANGE, this.formInvoice)
                    this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
                    this.$notify({
                        type: 'success',
                        text: trans('general.component.profile_widget.invoice_form.confirmation_sent')
                    });
                })
                .catch((error) => {
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0);
                        this.$notify({type: 'error', text: this.errors[0]});
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                    this.$wait.end(INVOICE_SUBMISSION_INDICATOR);
                });
        },
        parseForm(data) {
            const form = new FormData(data);

            if (this.files[0]) {
                form.append('file', this.files[0]);
            }

            return form;
        },

        async loadInvoice() {
            const response = await axios.get(`children/${this.invoice.child_id}/invoice/${this.invoice.id}`, {
                params: {
                    include: 'tax;documents'
                }
            });
            this.formInvoice = response.data.data
        }
    },
    mounted() {
        this.loadInvoice()
    }
}
</script>

<style scoped>
.header {
    border-bottom: solid 1px #f1f1f1;
}

.detail-item {
    border-bottom: solid 1px #dddfeb;
}

.detail-item:last-child {
    border: none;
}
.overdue {
    animation: glow 1s ease-in-out infinite alternate;
}
@-webkit-keyframes glow {
    from {
        text-shadow: 0 0 0px #D32F2F;
    }

    to {
        text-shadow: 0 0 15px #D32F2F;
    }
}
</style>
